import Container from "@mui/material/Container/Container";

import Stack from "@mui/material/Stack/Stack";
import Avatar from "@mui/material/Avatar/Avatar";
import * as React from "react";


function Stepper({stepNumber}) {
  const [step, setStep] = React.useState(stepNumber);

  return (
    <Container maxWidth={''} style={{paddingLeft: 0, paddingRight: 0, marginTop: 30, marginBottom:70}}>
      <div style={{width: '100%', height: 7, backgroundColor: '#E3E8F0'}}>
        <Container maxWidth={''} style={{paddingLeft: 0, paddingRight: 0,   position:'relative', top:'-33px'}} >
          <Stack
            direction="row"
            alignItems="center"
            spacing={0}
            sx={{
              height:70
            }}
          >
             <div style={{flex: 1, height: 7, backgroundColor: `${ step > 0 && step < 5 ? '#204488' : '#E3E8F0'}` }}/>

            <Avatar sx={{backgroundColor: `${ step > 0 && step < 5 ? '#204488' : '#E3E8F0'}` }}>
              1
            </Avatar>
            <div style={{flex: .5, height: 7, backgroundColor: `${step > 1 && step < 5 ? '#204488' : '#E3E8F0'}` }}/>
            <Avatar sx={{backgroundColor:  `${step > 1 && step < 5 ? '#204488' : '#E3E8F0'}`,color: `${step > 1 && step < 5 ? '#fff':  '#204488'}` }} >
              2
            </Avatar>
            <div style={{flex: .5, height: 7, backgroundColor: `${step > 2 && step < 5 ? '#204488' : '#E3E8F0'}` }}/>

            <Avatar sx={{backgroundColor: `${step > 2 && step < 5 ? '#204488' : '#E3E8F0'}`, color: `${step > 2 && step < 5 ? '#fff':  '#204488'}` }} >

              3
            </Avatar>
            <div style={{flex: .5, height: 7, backgroundColor: `${step > 3 && step < 5? '#204488' : '#E3E8F0'}` }}/>

            <Avatar sx={{backgroundColor:  `${step > 3 && step < 5? '#204488' : '#E3E8F0'}`, color: `${step > 3 && step < 5 ? '#fff':  '#204488'}` }} >
              4
            </Avatar>
            <div style={{flex: 1, height: 7, backgroundColor: '#E3E8F0'}}></div>

          </Stack>
        </Container>
      </div>
    </Container>
  )

}
export default  Stepper;